import { Injectable } from '@angular/core';
import { API } from './api.service';
import { ES } from './es.service';
import * as _ from 'lodash';

@Injectable()
export class AlbumsService {
    constructor(private api: API, private es: ES) {
    }

    public getAlbumsDetailsById(ids) {

        let queryParams = '';
        ids.forEach(function (arrayItem) {
            queryParams += 'id[]=' + arrayItem + '&';
        });
        return this.api.get('albums?' + queryParams);
    }

    public toggleAlbumToFavorites(id: string, domainInfo: any) {
        return this.api.post('albums/like', { object: id, domainInfo: domainInfo });
    }

    public getAlbumDetailsBySlug(slug: string) {
        return this.api.get('albums/by-slug/' + slug);
    }

    public getAlbumsForSearch(queryString: string, pageParams: any) {
        let options = this.es.setCriteria({}, 'album', pageParams, queryString);
        return this.es.listing(options).then((body) => {
            let hits = body.hits.hits;
            return _.keys(_.groupBy(hits, '_id'));
        });
    }

    public getAlbumsByIds(albumsIds) {
        let queryParams = '';
        albumsIds.forEach(function (arrayItem) {
            queryParams += 'id[]=' + arrayItem + '&';
        });
        return this.api.get('albums?' + queryParams);
    }
    public getAlbumById(albumsId) {
        let queryParams = '';
        queryParams += 'id[]=' + albumsId + '&';

        return this.api.get('albums?' + queryParams);
    }
    public fetchSongs(album: any) {
        return this.getAlbumDetailsBySlug(album.id).map((res) => {
            return res.songs;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/api/services/albums.service.ts